import React, { useContext } from "react";

import { SingletonRouter, withRouter, WithRouterProps } from "next/router";

const RouterContext = React.createContext<SingletonRouter<any> | undefined>(undefined);

const RouterContextProviderBase: React.FC<WithRouterProps> = ({ router, children }) => (
  <RouterContext.Provider value={router}>{children}</RouterContext.Provider>
);

const useRouter = <T extends Record<string, string | string[]>>():
  | SingletonRouter<T>
  | undefined => {
  return useContext(RouterContext);
};

const RouterContextProvider = withRouter(RouterContextProviderBase);

export { useRouter, RouterContextProvider };
